import React from "react";

const EditIcon = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4946_3081"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
        style={{ maskType: "alpha" }} // Corrected this line
      >
        <rect
          x="0.862305"
          y="0.284088"
          width="18.8522"
          height="18.8522"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_4946_3081)">
        <path
          d="M2.43359 19.1363V15.9943H18.1438V19.1363H2.43359ZM5.57563 12.8522H6.67535L12.8023 6.7449L11.683 5.62555L5.57563 11.7525V12.8522ZM4.00461 14.4233V11.0848L12.8023 2.30677C12.9463 2.16276 13.1133 2.05148 13.3031 1.97293C13.4929 1.89438 13.6926 1.8551 13.902 1.8551C14.1115 1.8551 14.3144 1.89438 14.5108 1.97293C14.7072 2.05148 14.8839 2.16931 15.041 2.32641L16.1211 3.42612C16.2782 3.57013 16.3928 3.74033 16.4648 3.9367C16.5368 4.13308 16.5728 4.33601 16.5728 4.54548C16.5728 4.74185 16.5368 4.93496 16.4648 5.12479C16.3928 5.31462 16.2782 5.48809 16.1211 5.64519L7.34303 14.4233H4.00461Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

EditIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: "black",
};

export default EditIcon;
